import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useFeatures } from '../lib/features';
import { canAccessSettings } from '../lib/roles';

// Sends the user to their home screen: the Dashboard, or Sales when the
// property has no Dashboard (or the user is a sales rep).
export const HomeRedirect = () => {
  const { user, loading } = useAuth();
  const { homePath } = useFeatures();
  if (loading || user === null) return null;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={homePath} replace />;
};

// Wraps a page that belongs to a feature. When the property has that
// feature switched off, the page is not reachable even by typing its URL.
const FeatureRoute = ({ feature, children }) => {
  const { user } = useAuth();
  const { on, homePath } = useFeatures();
  if (user && !on(feature)) return <Navigate to={homePath} replace />;
  return children;
};

// The Settings page: admins and accounting only. Everyone else (users, sales
// admins, sales reps) goes to their home screen, even by typing the URL.
export const SettingsRoute = ({ children }) => {
  const { user } = useAuth();
  const { homePath } = useFeatures();
  if (user && !canAccessSettings(user)) return <Navigate to={homePath} replace />;
  return children;
};

export default FeatureRoute;
